// ═══════════════════════════════════════════════════════════════════
// CONFIGURACIÓN DE LINKS PARA LINKTREE 2
// ═══════════════════════════════════════════════════════════════════
// 
// Para cambiar los links, solo modifica las URLs y nombres abajo.
// 
// Para agregar logos de redes diferentes:
//   1. Coloca los archivos SVG en: public/social_logos2/
//   2. Actualiza la ruta "logo" apuntando a /social_logos2/NombreArchivo.svg
//
// Logos disponibles en public/social_logos/:
//   - Facebook.svg
//   - Instagram.svg
//   - YouTube.svg
//   - Tiktok.svg
//   - LinkedIn.svg
//
// Si necesitas otros logos (WhatsApp, Twitter/X, Telegram, Spotify, etc.):
//   1. Descarga el SVG del logo
//   2. Colócalo en public/social_logos2/
//   3. Referencia la ruta aquí como /social_logos2/NombreLogo.svg
//
// ═══════════════════════════════════════════════════════════════════

// Iconos que se muestran arriba como íconos visuales (sin link directo)
export const socialIcons = [
    { name: 'Sitio Web', logo: '/social_logos2/SW.svg', url: 'https://www.liec.com.mx' },
    { name: 'WhatsApp', logo: '/social_logos2/WA.svg', url: 'https://wa.me/529991755327' },
    { name: 'Google Maps', logo: '/social_logos2/Maps.svg', url: 'https://maps.app.goo.gl/7Rwvz8y3QoQYrEYi8?g_st=iw' },
    { name: 'Facebook', logo: '/social_logos2/FB.svg', url: 'https://www.facebook.com/share/1BdvQqkVWV/' },
];

// Botones de enlaces clickeables que se muestran como lista
export const socialButtons = [
  { name: 'Sitio Web', logo: '/social_logos2/Facebook.svg', url: 'https://www.liec.com.mx' },
  { name: 'WhatsApp', logo: '/social_logos2/Instagram.svg', url: 'https://wa.me/529991755327' },
  { name: 'Google Maps', logo: '/social_logos2/YouTube.svg', url: 'https://maps.app.goo.gl/7Rwvz8y3QoQYrEYi8?g_st=iw' },
  { name: 'Facebook', logo: '/social_logos2/Tiktok.svg', url: 'https://www.facebook.com/share/1BdvQqkVWV/' },
  
];
